var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let BreakInDamageChoices = class BreakInDamageChoices extends Vue {
    update(value) {
        const data = {
            [this.valueName]: this.selectedValue !== value ? value : null,
        };
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
};
__decorate([
    layout.State('color')
], BreakInDamageChoices.prototype, "color", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], BreakInDamageChoices.prototype, "updateBreakInDamage", void 0);
BreakInDamageChoices = __decorate([
    Component({
        props: {
            changeKey: {
                type: [String, Number],
                default: null,
            },
            selectedValue: {
                type: [Boolean, String, Number],
                default: null,
            },
            valueName: {
                type: String,
                default: null,
            },
            types: {
                type: Array,
                default: [],
            },
            desktopGridLayout: {
                type: Number,
                default: 3,
            },
        },
    })
], BreakInDamageChoices);
export default BreakInDamageChoices;
